import { apiClient } from "./api";

// Google Form intake setup for one job.
//
// Intake is push: the tenant installs an Apps Script on their own Form which
// POSTs each submission to our webhook. Their Sheet and Drive stay private and we
// hold no Google credential.
//
// No store_id is sent anywhere — the backend derives the tenant from the session
// token's claims.
export const intakeService = {
  // Last received, counts, failures, and is_stale. A broken Apps Script trigger
  // fails silently, so is_stale is the only signal that intake has stopped.
  status: (jobId) => apiClient.get(`/intake/status/${jobId}`),

  // Proposes a canonical-field → Form-header mapping from the tenant's headers.
  // Pure suggestion; nothing is saved.
  suggestMap: (jobId, headers) =>
    apiClient.post(`/intake/map/${jobId}/suggest`, { headers }),

  saveMap: (jobId, columnMap) =>
    apiClient.post(`/intake/map/${jobId}`, { column_map: columnMap }),

  // Issues a token and returns the paste-ready script. The plaintext token is
  // returned ONCE and is not retrievable afterwards; rotating invalidates the
  // previous script immediately.
  rotateToken: (jobId) => apiClient.post(`/intake/token/${jobId}/rotate`),
};

// Canonical fields, in the order they are shown. `required` gates saving —
// without a consent question there is no lawful basis to import anyone, and
// without email or phone a candidate cannot be identified or de-duplicated.
export const INTAKE_FIELDS = [
  { key: "full_name", label: "Full name", required: true },
  {
    key: "email",
    label: "Email",
    help: "Email or phone is required — at least one must be mapped.",
  },
  { key: "phone", label: "Phone / WhatsApp" },
  {
    key: "resume",
    label: "Resume upload",
    help: "Must be a Form file-upload question. The script reads the file as the Form owner, so nothing needs sharing.",
  },
  {
    key: "consent",
    label: "Data-use consent",
    required: true,
    help: "A Yes/No question. Submissions without an affirmative answer are rejected, not imported.",
  },
  {
    key: "recording_consent",
    label: "Recording consent",
    help: "Separate from data-use consent — a candidate may accept one and decline the other.",
  },
  { key: "city", label: "City" },
  { key: "current_company", label: "Current company" },
  { key: "experience", label: "Experience" },
  { key: "linkedin_url", label: "LinkedIn" },
];

// Splits a pasted header row. Sheets copies as tab-separated; people also paste
// comma-separated or one-per-line.
export function parseHeaders(text) {
  return String(text || "")
    .split(/[\t\n\r]+|,(?=(?:[^"]*"[^"]*")*[^"]*$)/)
    .map((h) => h.replace(/^["\s]+|["\s]+$/g, ""))
    .filter(Boolean);
}
